import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { Box, Typography } from '@mui/material';
export const BalanceTransferIntroApr = t0 => {
  const $ = _c(10);
  const {
    creditCardOffer
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    apr: t2,
    balanceTransferIntroTime,
    billingCycleUnits
  } = t1;
  const {
    introBalanceTransfers: balanceTransferIntroApr
  } = t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      gap: 1
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== balanceTransferIntroTime || $[2] !== billingCycleUnits) {
    t4 = balanceTransferIntroTime && <Typography variant="textBold" sx={{
      fontSize: "inherit"
    }}>{balanceTransferIntroTime} {billingCycleUnits.toLowerCase()}</Typography>;
    $[1] = balanceTransferIntroTime;
    $[2] = billingCycleUnits;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: "inherit"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = balanceTransferIntroApr || "N/A";
  let t7;
  if ($[5] !== t6) {
    t7 = <Typography sx={t5}>{t6}</Typography>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t4 || $[8] !== t7) {
    t8 = <Box sx={t3}>{t4}{t7}</Box>;
    $[7] = t4;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};